import { render, staticRenderFns } from "./dlg_notice.vue?vue&type=template&id=48bfc3e0&scoped=true"
import script from "./dlg_notice.vue?vue&type=script&lang=js"
export * from "./dlg_notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfc3e0",
  null
  
)

export default component.exports